export default [
  {
    key: 'id',
    title: '包ID',
    width: 46
  },
  {
    key: 'dmpName',
    title: 'DMP包名称',
    width: 140
  },
  {
    key: 'remark',
    title: '备注',
    width: 200,
    overflow: true
  },
  {
    key: 'platform',
    title: '平台',
    width: 64
  },
  {
    key: 'dmpType',
    title: '设备类型',
    width: 84,
    overflow: true
  },
  {
    key: 'createOpName',
    title: '创建人',
    width: 64
  },
  {
    key: 'upOpName',
    title: '更新人',
    width: 64
  },
  {
    key: 'createTime',
    title: '创建时间',
    width: 130
  },
  {
    key: 'updateTime',
    title: '更新时间',
    width: 130
  },
  {
    key: 'synTime',
    title: '包体更新时间',
    width: 130
  },
  {
    key: 'total',
    title: '数量',
    width: 64
  },
  {
    key: 'dmpStatus',
    title: '状态',
    width: 192,
    overflow: true
  },
  {
    key: 'autoSwitch',
    title: '自动更新',
    width: 72
  },
  {
    key: 'excludeMediaNames',
    title: '自动排除媒体',
    width: 158
  },
  {
    key: 'control',
    title: '操作',
    width: 150,
    fixed: 'right'
  }
]
